<template>
  <div
    @wheel.prevent="wheel"
    :style="{
  padding:padding/2 + 'px',
  width:(innerWidth - padding)+'px',
  height:(innerHeight - padding)+'px',
  overflow:'hidden'
}">
    <div class="lfs-map-preloader" v-if="loading">

      <div class="lfs-map-preloader-background"></div>
      <v-progress-circular
        :size="200"
        :width="7"
        color="#2D9CDB"
        indeterminate
      ></v-progress-circular>

    </div>
    <div v-if="canvas" style="position: absolute; right: 10px;">
      <b>{{ Math.trunc(canvas.viewportTransform[0] * 100) }}%</b>
      <b v-if="testView">Tap </b> <br>
      <b>{{touches}} </b> <br>
      <b>{{mouse}} </b> <br>


    </div>
    <canvas
      id="canvas"
    >
    </canvas>

  </div>
</template>

<script>


import axios from "axios";
import {fabric} from 'fabric-with-gestures'



export default {
  name: "MapView",
  data() {
    return {
      mouse:null,
      canvasMouseMoveTap:false,
      setState:null,
      testView:false,
      zoomStart:null,
      buildElement: 0,
      zoomDelta: 0.05,
      clickStand: true,
      AppMobileEvent: false,
      map: null,
      touches: null,
      etype: null,
      startMoveX: null,
      startMoveY: null,
      zoomStartScale: null,
      canvasMousePress: false,
      centerPoint: null,
      padding: 20,
      canvas: null,
      innerWidth: null,
      innerHeight: null,
      zoom: 1,
      color: null,
      loading: true
    }
  },
  methods: {
    changeButtonColorFun(color) {
      this.AppMobileEvent = true
      this.color = color
      // document.getElementById("block").style.color=color
    },
    clickByStand(standName) {
      window.ok.goToMobile(JSON.stringify({type: 'stand', value: standName}))
      // this.clickStand = standName
    },
    myEventHandler() {
      console.log('resize')
    },
    getCoordsCanvas() {

      this.canvas.getObjects().map((el) => {
        el.set('event', {
          type: el.event.type,
          value: el.event.value
        })
      })
      const allElement = new fabric.Group(this.canvas.getObjects(), {
        originX: 'center',
        originY: 'center',
      });

      this.map = allElement
      this.canvas.renderAll()
      allElement.center()

      const deltaXzoom = this.canvas.width / allElement.width
      const deltaYzoom = this.canvas.height / allElement.height

      let zoom = this.canvas.getZoom()



      if (deltaXzoom <= deltaYzoom) {
        zoom = zoom * deltaXzoom
      } else {
        zoom = zoom * deltaYzoom
      }

      this.zoomStart = zoom


      let panX = ((this.canvas.getWidth() / zoom / 2) - (allElement.aCoords.tl.x) - (allElement.width / 2)) * zoom
      let panY = ((this.canvas.getHeight() / zoom / 2) - (allElement.aCoords.tl.y) - (allElement.height / 2)) * zoom
      this.canvas.setViewportTransform([zoom, 0, 0, zoom, panX, panY])

      this.zoom = this.canvas.getZoom()
      this.canvas.renderAll();
      this.loading = false

    },
    wheel(e) {
      let delta = e.deltaY;
      let zoom = this.canvas.getZoom();
      zoom *= 0.999 ** delta;
      if (zoom > 1) zoom = 1;
      if (zoom < this.zoomStart) zoom = this.zoomStart;
      this.canvas.zoomToPoint({x: e.offsetX, y: e.offsetY}, zoom);
      e.preventDefault();
      e.stopPropagation();


      this.canvas.forEachObject((el) => {
        if (el && el.event && el.event.type === 'opacity') {

          if (this.canvas.getZoom() > el.event.value && el.opacity == 1) {
            el.animate('opacity', 0, {
              onChange: this.canvas.renderAll.bind(this.canvas),
              duration: 600
            });
            el.set('evented', false)

          }

          if (this.canvas.getZoom() < el.event.value && el.opacity == 0) {
            el.animate('opacity', 1, {
              onChange: this.canvas.renderAll.bind(this.canvas),
              duration: 600
            });
            el.set('evented', true)

          }
        }

        if (el && el.event && el.event.type === 'opacityDown') {
          if (this.canvas.getZoom() > el.event.value) {
            el.animate('opacity', 1, {
              onChange: this.canvas.renderAll.bind(this.canvas),
              duration: 600
            });
          } else {
            el.animate('opacity', 0, {
              onChange: this.canvas.renderAll.bind(this.canvas),
              duration: 600
            });
          }
        }


      })

    },
    canvasTouchGesture(event) {
      setTimeout(()=>{
        if (event.e.touches &&  event.e.touches.length == 2) {
          this.touches = 2
          let point = new fabric.Point(event.self.x, event.self.y);
          if (event.self.state == "start") {
            this.zoomStartScale = this.canvas.getZoom();
          }
          let delta;
          if (this.zoomStartScale * event.self.scale > this.zoom) {
            delta = this.zoomStartScale * event.self.scale
          } else {
            delta = this.zoom
          }
          if (this.zoomStartScale * event.self.scale < 1) {
            this.canvas.zoomToPoint(point, delta);
            this.canvas.forEachObject((el) => {
              if (el && el.event && el.event.type === 'opacity') {
                if (this.canvas.getZoom() > el.event.value && el.opacity == 1) {
                  el.animate('opacity', 0, {
                    onChange: this.canvas.renderAll.bind(this.canvas),
                    duration: 600
                  });
                  el.set('evented', false)
                }
                if (this.canvas.getZoom() < el.event.value && el.opacity == 0) {
                  el.animate('opacity', 1, {
                    onChange: this.canvas.renderAll.bind(this.canvas),
                    duration: 600
                  });
                  el.set('evented', true)
                }
              }
              if (el && el.event && el.event.type === 'opacityDown') {
                if (this.canvas.getZoom() > el.event.value) {
                  el.animate('opacity', 1, {
                    onChange: this.canvas.renderAll.bind(this.canvas),
                    duration: 600
                  });
                } else {
                  el.animate('opacity', 0, {
                    onChange: this.canvas.renderAll.bind(this.canvas),
                    duration: 600
                  });

                }
              }
            })
          }
        }
      },100)

    },
    canvasTouchDrag(e) {
      // console.log('canvasTouchDrag',e.e &&  e.e.type ? e.e.type : 'mouseup')
      // if(e.e &&  e.e.type){
      //   if(e.e.type === 'mousedown'){
      //     console.log('удар мыши');
      //     this.mouse = 'удар мыши'
      //   }
      //   if(e.e.type === 'mousemove'){
      //     console.log('перетаскиваем мыш');
      //     this.mouse = 'перетаскиваем мыш'
      //   }

      // }else {
      //   console.log('мыш поднята');
      //   this.mouse = 'мыш поднята'
      // }
      // console.log('canvasTouchDrag',e)
        if (e.e.touches && e.e.touches.length == 1 ) {
          this.touches = e.e.touches.length
          if (e.e.type === 'touchstart') {
            this.startMoveX = e.e.touches[0].pageX
            this.startMoveY = e.e.touches[0].pageY
          }
          if (e.e.type === 'touchmove') {
            const mEvent = e.self
            const x = mEvent.x - this.startMoveX
            const y = mEvent.y - this.startMoveY
            if (x) {
              const delta = new fabric.Point(x, y)
              this.canvas.relativePan(delta)
              this.startMoveX = mEvent.x
              this.startMoveY = mEvent.y
            }
          } else {
            this.startMoveX = e.e.touches[0].pageX
            this.startMoveY = e.e.touches[0].pageY
          }
        }
    },
    canvasTouchLongpress(e) {
      this.clickStand = !this.clickStand
      // this.etype = e.e.type
      // console.log('canvasTouchLongpress')
    },
    testFun(e) {
      this.canvasMouseDown(e)
      if (e.target && e.target.event && e.target.event.type === 'stand') {
        e.target.set('fill', e.target.fill !== 'red' ? 'red' : 'blue')
        this.canvas.renderAll()
      }
    },
    canvasMouseDown(e) {
      console.log('canvasMouseDown----------------------->')
      setTimeout(()=>{
        if (!this.canvasMouseMoveTap && e.subTargets.length > 0 && e.subTargets[0].event && e.subTargets[0].event.type === 'stand') {
          try {
            this.clickByStand(e.subTargets[0].event.value)
          }catch (e) {
            console.log('кликнули по стенду')
            this.testViewFun()
          }
        }
      },200)
      this.touches = 1
      this.canvasMousePress = true
    },
    canvasMouseUp() {
      this.touches = 0
      this.canvasMousePress = false
      this.canvasMouseMoveTap = false
    },
    canvasMouseMove(event) {
      this.canvasMouseMoveTap = true
      if (this.canvasMousePress) {
        const mEvent = event.e
        const x = mEvent.movementX
        const y = mEvent.movementY
        if (x) {
          const delta = new fabric.Point(mEvent.movementX, mEvent.movementY)
          // console.log(delta)
          this.canvas.relativePan(delta)
        }
      }
    },
    getCanvasJSONFromServer() {
      return axios
        .get('/v4/show/' + this.$route.params.code + '/interactive-map')
        .then((resp) => {
          return resp.data.data
        })
        .catch((error) => {
          console.log('code', error.response.status)
          console.log('msg', error.response.data.error)
          return false
        })
    },
    AppMobileEventFun() {
      this.AppMobileEvent = !this.AppMobileEvent
    },
    setCanvas() {
      let element = new fabric.Rect({
        strokeWidth: 1,
        stroke: 'grey',
        fill: 'grey',
        width: this.innerWidth - this.padding,
        height: this.innerHeight - this.padding,
        opacity: 0.6,
        left: 0,
        top: 0,
        noScaleCache: false,
        strokeUniform: true,
      });
      this.canvas.add(element)
      element.sendToBack()
      this.canvas.renderAll()
    },
    zoomPlus() {
      if( this.canvas.getZoom() < 1){
        this.canvas.setZoom(this.canvas.getZoom() + this.zoomDelta)
      }

    },
    zoomMinus() {
      if( this.canvas.getZoom() > this.zoomStart){
        this.canvas.setZoom(this.canvas.getZoom() - this.zoomDelta)
      }

    },
    testViewFun(){
      this.testView = !this.testView
    }


  },
  async mounted() {
    window.zoomPlus = this.zoomPlus
    window.zoomMinus = this.zoomMinus
    this.innerWidth = window.innerWidth
    this.innerHeight = window.innerHeight
    this.canvas = new fabric.Canvas('canvas',
      {
        controlsAboveOverlay: false,
        defaultCursor: 'default',
        hoverCursor: 'default',
        width: this.innerWidth - this.padding,
        height: this.innerHeight - this.padding,
        selection: false
      });

    const data = await this.getCanvasJSONFromServer()


    this.canvas.loadFromJSON(data.mapView, () => {
      // setNewMap(this.canvas,()=>{
      //
      // })
      this.canvas.set({
        selection: false
      })
      this.getCoordsCanvas()
      this.loading = false
    })


    function setNewMap(canvas) {
      canvas.getObjects().forEach((el) => {
        if (!el.visible) {
          canvas.remove(el)
        }
      })
      let lay = data.layouts.filter(el => el.objects.length > 0 && el.objects.filter(el => el[1]).length > 0)

      lay.reverse().map((el, i) => {

        let group = new fabric.Group()
        group.set('title', i + ' группа')
        group.set('event', el.event)
        group.set('subTargetCheck', true)
        group.set('selectable', false)
        group.set('objectCaching', false)
        canvas.add(group)


        el.objects.reverse().forEach((object) => {
          if (object[1]) {
            let objClone = canvas.getObjects().filter(elem => elem.id === object[4])[0]
            objClone.set('selectable', false)
            if (objClone) {
              group.addWithUpdate(objClone)
              canvas.remove(objClone)
            }
          }
        })


      })
      canvas.renderAll()
      console.log('колько объектов?', canvas.getObjects());

    }


    this.canvas.on('mouse:move', this.canvasMouseMove)
    this.canvas.on('mouse:up', this.canvasMouseUp)
    this.canvas.on('mouse:down', this.testFun)
    this.canvas.on("touch:drag", this.canvasTouchDrag);
    // this.canvas.on("touch:gesture", this.canvasTouchGesture);



    // this.canvas.on("mouse:dblclick", this.testViewFun);
    //
    //
    // this.canvas.on("mouse:dblclick", this.testViewFun);
    // this.canvas.on("touch:longpress", this.testViewFun);
    // this.canvas.on("touch:drag", this.canvasMouseMove);


  },
  async created() {
    window.addEventListener("resize", this.myEventHandler);
    window.appResumeEvent = new Event('AppMobileEvent');
    window.zoomPlus = new Event('zoomPlus');
    window.zoomMinus = new Event('zoomMinus');
    window.addEventListener('AppMobileEvent', this.AppMobileEventFun, false);

  }
}
</script>

<style lang="scss" scoped>
.lfs-map-preloader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  &-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
  }
}

</style>
